const warning = {
  25: '#FFFDFA',
  50: '#FFF8EB',
  100: '#FEEAC7',
  200: '#FDD28A',
  300: '#FCBB4D',
  400: '#FBAB24',
  500: '#F59E0B',
  600: '#D98B06',
  700: '#B47409',
  800: '#92610E',
  900: '#452C03',
};
export default warning;